import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { postData, fetchData, fetchhistory } from '../../../apiService';
import Button from '@mui/material/Button';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { Tooltip } from '@mui/material';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CallIcon from '@mui/icons-material/Call';
import CircularProgress from '@mui/material/CircularProgress';
import { FaTimes } from 'react-icons/fa';
import SyncIcon from '@mui/icons-material/Sync';
import AsyncSelect from 'react-select/async';

export const ServiceRequestForm = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token, companyName } = useAuth();
    const [Remark, setRemark] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState("");
    const [IsPriority, setIsPriority] = useState(""); // for Identify the Priority Call List

    const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout, companyId, companyName]);
    const [isLoading, setIsLoading] = useState(false);

    //Work Type
    const [workTypeOptions, setWorkTypeOptions] = useState([]);
    const [selectedWorkType, setSelectedWorkType] = useState("");

    const fetchWorkTypes = async () => {
        try {
            const response = await fetchData('WorkStatusApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                setWorkTypeOptions(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Work Types:', error);
        }
    };


    useEffect(() => {
        fetchCustomerTypes();
        fetchWarrantyTypes();
        fetchWorkTypes();
        //fetchRequestTypes();
        fetchProductTypes();
    }, []);


    const [customer, setCustomer] = useState('');
    const [contactNumber1, setContactNumber1] = useState('');
    // const [contactNumber2, setContactNumber2] = useState('');
    //const [addressline1, setAddressLine1] = useState("");
    const [town, setTown] = useState("");
    const [pincode, setPostcode] = useState("");
    const [district, setDistrict] = useState("");
    const [state, setState] = useState("");
    const [customertype, setCustomertype] = useState('');
    const [contactperson, setContactperson] = useState('');
    const [email, setEmail] = useState("");

    const [landmark, setLandmark] = useState('');

    useEffect(() => {
        fetchData('CustomerApi', `/${companyId}`)
            .then((response) => {
                if (response.responseCode == '1111') {
                    setCustomerName(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Customer:', error);
            });
    }, []);



    //Customer create Modal
    const [modal, setModal] = useState("");

    const [names, setNames] = useState("");
    const [emails, setEmails] = useState("");
    const [gstNumbers, setGstNumbers] = useState("");
    const [contactNumber1s, setContactNumber1s] = useState("");
    const [contactNumber2s, setContactNumber2s] = useState("");
    const [addressline1s, setAddressLine1s] = useState("");
    const [addressline2s, setAddressLine2s] = useState("");
    const [landMarks, setLandMarks] = useState("");
    const [towns, setTowns] = useState("");
    const [pincodes, setPostcodes] = useState("");
    const [contactPersons, setcontactPersons] = useState("");
    const [districts, setDistricts] = useState("");
    const [states, setStates] = useState("");
    const [countrys, setCountrys] = useState("");
    const [customerTypeIDs, setCustomerTypeIDs] = useState("");
    const [customerTypeOptionss, setcustomerTypeOptionss] = useState([]);
    const [selectedCustomerTypes, setSelectedCustomerTypes] = useState("");
    //const [pinCodess, setPinCodess] = useState([]);
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [companyCallNo, setCompanyCallNo] = useState("");
    const [callSerialNo, setCallSerialNo] = useState("");
    const [amc, setAMC] = useState("");

    const [pinCodess, setPinCodess] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 4) {
            return [];
        }

        const response = await fetchData('PinCodeApi', `/${companyId}/${inputValue}`, token);
        if (response) {
            const data = await response;
            setPinCodess(data);  // Move this line outside the if block
            return data.map(item => ({
                value: item.id,
                label: item.postcode,
            }));
        }
        return [];
    };

    const handleInputChange = (newValue) => newValue;

    const handleChangeDrop = (selectedOption) => {
        setSelectedOption(selectedOption);
        const selectedItemDetail = pinCodess.find(pincode => pincode.id === selectedOption.value);
        if (selectedItemDetail) {
            setTowns(selectedItemDetail.city);
            setDistricts(selectedItemDetail.district);
            setPostcodes(selectedItemDetail.postcode);
            setCountrys(selectedItemDetail.country);
            setStates(selectedItemDetail.state);
        }
    };

    const [warrentyDate, setWarrentyDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with current date 
    const [renewalDate, setRenewalDate] = useState(new Date().toISOString().split('T')[0]); // Initialize with current date renewalDate

    const [selectedAMC, setSelectedAMC] = useState("1");
    const handleChanges = (event) => {
        setSelectedAMC(event.target.value);
    };
    const handleToDateChange = (e) => {
        setRenewalDate(e.target.value);
    };
    const handleToDateChangeWarrentyDate = (e) => {
        setWarrentyDate(e.target.value);
    };


    const submitCustomData = async (e) => {
        e.preventDefault();
        if (!names || !contactNumber1s) {
            setErrorMessages("All fields are required!");
            return;
        }

        try {

            const CustomerCreateData = {
                CustomerName: names,
                CompanyID: companyId,
                CustomerTypeID: selectedCustomerType.value,
                ContactNumber1: contactNumber1s,
                ContactNumber2: contactNumber2s,
                Email: emails,
                GSTNumber: gstNumbers,
                AddressLine1: addressline1s,
                AdressLine2: addressline2s,
                LandMark: landMarks,
                PinCode: pincodes,
                Town: towns,
                District: districts,
                State: states,
                Country: countrys,
                GPSLocation: null,
                ContactPerson: contactPersons,
                CreatedBy: userId,
                CreatedDate: new Date(),
                AMC: selectedCustomerWarrantyOptionsType.value,
                WarrentyExpireDate: warrentyDate || null,
                RenewalExpireDate: null
            };

            postData('CustomerApi', CustomerCreateData, token)
                .then((response) => {
                    console.log('Customer Created success:', response);
                    setNames("");
                    setContactNumber1s("");
                    setContactNumber2s("");
                    setAddressLine1s("");
                    setAddressLine2s("");
                    setPostcodes("");
                    setEmails("");
                    setGstNumbers("");
                    setPinCodess("");
                    setLandMarks("");
                    setTowns("");
                    setcontactPersons("");
                    setDistricts("");
                    setStates("");
                    setCountrys("");
                    setSelectedCustomerType("");
                    setWarrentyDate("");
                    setRenewalDate("");
                    setSuccessMessages("customer Created successful!");
                    setErrorMessages(""); // Clear error message on success
                    // Reload the page after successful submission
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                });
        } catch (error) {
            console.error('Item Create error:', error);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
        setNames("");
        setContactNumber1s("");
        setContactNumber2s("");
        setAddressLine1s("");
        setAddressLine2s("");
        setPostcodes("");
        setEmails("");
        setGstNumbers("");
        setPinCodess("");
        setLandMarks("");
        setTowns("");
        setcontactPersons("");
        setDistricts("");
        setStates("");
        setCountrys("");
        setSelectedCustomerType("");
        setWarrentyDate("");
        setRenewalDate("");
        setSelectedCustomerWarrantyOptionsType("");
        setSelectedCustomerTypes("");

    };

    const closeModal = () => {
        setIsModalOpen(false);
        //window.location.reload();
    };



    const handleRequestTypeChange = (selectedOption) => {
        setSelectedRequestType(selectedOption);
    };

    //Warrenty Type

    const [warrantyTypeOptions, setWarrantyTypeOptions] = useState([]);
    const [selectedWarrantyType, setSelectedWarrantyType] = useState("");

    const fetchWarrantyTypes = async () => {
        try {
            const response = await fetchData('WarrentyStatusApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(warranty => ({
                    value: warranty.id, // type
                    label: warranty.type
                }));
                setWarrantyTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Warrenty Types:', error);
        }
    };

    const handleWarrantyChange = (selectedOption) => {
        setSelectedWarrantyType(selectedOption);
    };



    // States for the dropdowns
    const [productTypeOptions, setProductTypeOptions] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState(null);

    const [requestTypeOptions, setRequestTypeOptions] = useState([]);
    const [selectedRequestType, setSelectedRequestType] = useState(null);

    const [PmodelTypeOptions, setPmodelTypeOptions] = useState([]);
    const [selectedPmodelType, setSelectedPmodelType] = useState(null);

    useEffect(() => {
        fetchProductTypes();
    }, []);

    // Fetch product types (categories)
    const fetchProductTypes = async () => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setProductTypeOptions(options); // Populate product categories
            }
        } catch (error) {
            console.error('Error fetching Product Types:', error);
        }
    };

    // Handle product category change
    const handleProductChange = async (selectedOption) => {
        setSelectedProductType(selectedOption); // Set selected product category
        setRequestTypeOptions([]); // Clear brand options
        setPmodelTypeOptions([]);  // Clear model options
        setSelectedRequestType(null); // Reset selected brand
        setSelectedPmodelType(null);  // Reset selected model

        try {
            // Fetch brands based on the selected product category
            const response = await fetchData('BrandApi', `/${companyId}/${selectedOption.value}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(type => ({
                    value: type.ID,
                    label: type.Name
                }));
                setRequestTypeOptions(options); // Populate brand options
            }
        } catch (error) {
            console.error('Error fetching Brands:', error);
        }
    };

    // Handle brand change
    const handleBrandChange = async (selectedOption) => {
        setSelectedRequestType(selectedOption); // Set selected brand
        setPmodelTypeOptions([]);  // Clear model options
        setSelectedPmodelType(null);  // Reset selected model

        try {
            // Fetch product models based on the selected brand and category
            // const response = await fetchData('ProductModalApi', `/PmodelGetByBrandId/${selectedOption.value}`);
            const response = await fetchData('ProductModalApi', `/PmodelGetByBrandId/${selectedOption.value}`, token)
            if (response.responseCode === '1111') {
                const options = response.response_data.map(PModel => ({
                    value: PModel.id,
                    label: PModel.model
                }));
                setPmodelTypeOptions(options); // Populate product model options
            }
        } catch (error) {
            console.error('Error fetching Product Models:', error);
        }
    };

    // Handle model change
    const handleModelChange = (selectedOption) => {
        setSelectedPmodelType(selectedOption); // Set selected model
    };


    //customer type
    const fetchCustomerTypes = async () => {
        try {
            const response = await fetchData('CustomerTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.type
                }));
                setCustomerTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };
    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
    };

    const [selectedCompanies, setSelectedCompanies] = useState("");

    const [brandname, setBrandname] = useState("");
    const [billno, setBillno] = useState("");

    const companyMapping = {
        "1": "Others",
        "2": "Schneider",
        "3": "Brother"
    };

    const handleChange = (e) => {
        const selectedValue = e.target.value;
        setSelectedCompanies(selectedValue);

        const selectedCompanyName = companyMapping[selectedValue];
        setBrandname(selectedCompanyName);

        fetchData('RescheduleTaskApi', `/${companyId}/${selectedCompanyName}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    console.log(response);
                    setBillno(response.response_data);
                }
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    };




    const [customerName, setCustomerName] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [customerNoOptions, setCustomerNoOptions] = useState([]);
    const [selectedCustomerNo, setSelectedCustomerNo] = useState(null);
    const [customerID, setCustomerID] = useState(null);
    const [addressLine1, setAddressLine1] = useState("");
    const [amcExpire, setAMCExpire] = useState("");

    //customerWarranty Options
    const [customerRemarks, setCustomerRemarks] = useState("");
    const [selectedCustomerWarrantyOptions, setSelectedCustomerWarrantyOptions] = useState("");
    const [customerWarrantyOptionsOptions, setCustomerWarrantyOptionsOptions] = useState([]);
    const [selectedCustomerWarrantyOptionsType, setSelectedCustomerWarrantyOptionsType] = useState("");

    const fetchCustomerWarrantyOptions = async () => {
        try {
            const response = await fetchData('ServiceRequestTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.status
                }));
                setCustomerWarrantyOptionsOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };

    const handleCustomerWarrantyChange = (selectedOption) => {
        setSelectedCustomerWarrantyOptionsType(selectedOption);
    };

    useEffect(() => {
        fetchCustomerWarrantyOptions();
    }, []);


    useEffect(() => {
        fetchData('CustomerApi', `/${companyId}`)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const customers = response.response_data;
                    setCustomerName(customers);

                    const optionsByName = customers.map(customer => ({
                        value: customer.id,
                        label: customer.customerName
                    }));
                    setCustomerOptions(optionsByName);

                    const optionsByNumber = customers.map(customer => ({
                        value: customer.id,
                        label: customer.contactNumber1
                    }));
                    setCustomerNoOptions(optionsByNumber);
                }
            })
            .catch((error) => {
                console.error('Error fetching Customer:', error);
            });
    }, [companyId]);

    const handleCustomerChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedCustomer(selectedOption);
            setCustomerID(selectedOption.value);

            const selectedCustomerData = customerName.find(customer => customer.id === selectedOption.value);
            if (selectedCustomerData) {
                setSelectedCustomerNo({
                    value: selectedCustomerData.id,
                    label: selectedCustomerData.contactNumber1
                });
                setContactNumber1(selectedCustomerData.contactNumber1);
                //setContactNumber2(selectedCustomerData.contactNumber2);
                setEmail(selectedCustomerData.email);
                setCustomertype(selectedCustomerData.customertype);
                setContactperson(selectedCustomerData.contactPerson);
                setAddressLine1(`${selectedCustomerData.town}, ${selectedCustomerData.pinCode}, ${selectedCustomerData.district}, ${selectedCustomerData.state}`);
                setLandmark(selectedCustomerData.landMark);
                setAMC(selectedCustomerData.amCwarranty);
                // const dateTimeString = selectedCustomerData.warrentyExpireDate;
                // const dateOnly = dateTimeString.split('T')[0];
                // setAMCExpire(dateOnly);
                const dateTimeString = selectedCustomerData.warrentyExpireDate;
                if (dateTimeString) {
                    const dateOnly = dateTimeString.split('T')[0]; 
                    setAMCExpire(dateOnly); 
                } else {
                    setAMCExpire('No Date'); 
                }


            }
        } else {
            clearCustomerData();
        }
    };

    const handleCustomerNoChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedCustomerNo(selectedOption);
            setCustomerID(selectedOption.value);

            const selectedCustomerNoData = customerName.find(customer => customer.id === selectedOption.value);
            if (selectedCustomerNoData) {
                setSelectedCustomer({
                    value: selectedCustomerNoData.id,
                    label: selectedCustomerNoData.customerName
                });
                setContactNumber1(selectedCustomerNoData.contactNumber1);
                //setContactNumber2(selectedCustomerNoData.contactNumber2);
                setEmail(selectedCustomerNoData.email);
                setCustomertype(selectedCustomerNoData.customertype);
                setContactperson(selectedCustomerNoData.contactPerson);
                setAddressLine1(`${selectedCustomerNoData.town}, ${selectedCustomerNoData.pinCode}, ${selectedCustomerNoData.district}, ${selectedCustomerNoData.state}`);
                setLandmark(selectedCustomerNoData.landMark);
                // const dateTimeString = selectedCustomerNoData.warrentyExpireDate;
                // const dateOnly = dateTimeString.split('T')[0];
                // setAMCExpire(dateOnly);
                const dateTimeString = selectedCustomerNoData.warrentyExpireDate;
                if (dateTimeString) {
                    const dateOnly = dateTimeString.split('T')[0]; 
                    setAMCExpire(dateOnly); 
                } else {
                    setAMCExpire('No Date'); 
                }
                setAMC(selectedCustomerNoData.amCwarranty);
                setAMCExpire(amcExpire);
            }
        } else {
            clearCustomerData();
        }
    };

    const clearCustomerData = () => {
        setSelectedCustomer(null);
        setSelectedCustomerNo(null);
        setSelectedCustomerNo("");
        setCustomerID(null);
        setContactNumber1("");
        //setContactNumber2("");
        setEmail("");
        setCustomertype("");
        setContactperson("");
        setAddressLine1("");
        setLandmark("");
        setAMC("");
        setAMCExpire("");
        setSelectedCustomerWarrantyOptionsType("");
    };


    const [showTable, setShowTable] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeModals = () => {
        setShowModal(false);
    };

    const isModalOpens = showModal;

    const handleHistoryClick = () => {
        console.log("History button clicked");
        if (showTable) {
            setShowTable(false);
        } else {
            fetchserviceDetails();
            //fetchhistory();
            setShowModal(true);
        }
    };
    const [historys, sethistorys] = useState([]);


    const fetchserviceDetails = async () => {
        try {
            const response = await fetchhistory('EngineerVisitApi', companyId, customerID, token);
            if (response.responseCode === '1111') {
                sethistorys(response.response_data);
                console.log(response);
            } else {
                console.error('Error fetching Request Details:', response.ErrorMessage);
            }
        } catch (error) {
            console.error('Error fetching Request Details:', error);
        }
    };

    useEffect(() => {
        if (companyId && customerID && token) {
            fetchserviceDetails();
        }
    }, [companyId, customerID, token]);

    const handleHistoryBackButtonClick = () => {

        setShowModal(false);
    };


    // Function to get the background color based on workstatus
    function getStatusColor(workstatus) {
        switch (workstatus) {
            case 'OnHold':
                // return 'yellow';#BB73E0 and #FF8DDB
                return '#FADBD8';
            case 'Completed':

                // return '#0CCDA3'; // Green
                return '#81BE83'; // Green
            case 'InProgress':
                return '#ECEBBD';
            case 'New':
                return '#ECEBBD';
            default:
                return 'white';
        }
    }

    // Add Product Modal.
    const [productModelOptions, setProductModelOptions] = useState([]);
    const [selectedProductModel, setSelectedProductModel] = useState("");
    const fetchProductModal = async () => {
        try {
            const response = await fetchData('ProductModalApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(productmodel => ({
                    value: productmodel.Id,
                    label: productmodel.Model
                }));
                setProductModelOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Product Modal:', error);
        }
    };
    const handleProductModalChange = (selectedOption) => {
        setSelectedProductModel(selectedOption);
    };

    useEffect(() => {
        fetchProductModal();
    }, []);


    const submitData = async (e) => {
        e.preventDefault();
        if (!selectedCustomer || !selectedRequestType || !selectedProductType || !selectedWarrantyType) {
            setErrorMessages("All fields are required!");
            return;
        }

        try {

            const RequestCreateData = {
                // Customer: selectedCustomer.label,
                CustomerID: selectedCustomer.value,
                CompanyID: companyId,
                Modal: modal,
                // ModelID: selectedProductModel.value,
                ModelID: selectedPmodelType.value,
                CategoryID: selectedProductType.value,
                ProductID: selectedProductType.value,
                BrandID: selectedRequestType.value,
                WarrentyStatusID: selectedWarrantyType.value,
                WorkStatusID: 1,
                StaffAppointmentID: null,
                Remarks: Remark,
                AllocatedBy: null,
                AllocatedDate: null,
                ReAllocatedDate: null,
                CreatedBy: userId,
                CreatedDate: new Date(),
                CallNo: billno.BillNumber,
                CallSerialNo: billno.CallSerialNo,
                Checking_Company: selectedCompanies,
                CompanyCallNo: companyCallNo || null,
                AMC: null,
                IsPriority: IsPriority,
                // RenewalExpireDate: null,
                WarrentyExpireDate: null
            };

            postData('ServiceRequestApi', RequestCreateData, token)
                .then((response) => {
                    console.log('Request Created success:', response);
                    setSelectedCustomer(null);
                    setCustomertype("");
                    setContactNumber1("");
                    setCompanyCallNo("");
                    setSelectedCompanies("1");
                    setCallSerialNo("");
                    setAddressLine1("");
                    setLandmark("");
                    setEmail("");
                    setContactperson("");
                    setSelectedRequestType("");
                    setSelectedProductType("");
                    setSelectedWarrantyType("");
                    setSelectedProductModel("");
                    setModal("");
                    setRemark("");
                    setAMC("");
                    setAMCExpire("");
                    setSuccessMessage("Call Registration successfully!");
                    setErrorMessages("");

                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000); // 3 seconds
                    // history.push('/ServiceRequestForm');
                    window.location.reload();
                })
                .catch((error) => {
                    console.error('Request Create error:', error);
                    setErrorMessages("Failed to create Call. Please try again later.");
                });

        } catch (error) {
            console.error('Request Create error:', error);
            setErrorMessages("An error occurred. Please try again later.");
        }
    };


    return (
        <Fragment>
            <div style={{ backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bolder' }}>
                {successMessage && <p className="text-blue-500">{successMessage}</p>}
            </div>
            <div className="w-full max-w-sm container mt-4 mx-auto">
                <form onSubmit={submitData}>
                    <div className="w-full mb-2 flex items-center">
                        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>SERVICE REGISTRATION</h6>
                        <Tooltip title="History">
                            <Button onClick={handleHistoryClick} style={{ color: 'darkmagenta', fontWeight: 'bolder' }} disabled={isLoading}>
                                <SyncIcon /> {isLoading ? <CircularProgress size={24} color="inherit" /> : "History"}
                            </Button>
                        </Tooltip>
                        |
                        <Tooltip title="Add a new Customer">
                            <Button onClick={openModal} style={{ color: 'darkred', fontWeight: 'bolder' }} disabled={isLoading}>
                                <PersonAddIcon /> {isLoading ? <CircularProgress size={24} color="inherit" /> : "New Customer"}
                            </Button>
                        </Tooltip>
                        |
                        <Tooltip title="Add to Call List">

                            <Button onClick={submitData} style={{ color: 'darkgreen', fontWeight: 'bolder' }} disabled={isLoading}>
                                <CallIcon /> {isLoading ? <CircularProgress size={24} color="inherit" /> : "Add Call"}
                            </Button>

                        </Tooltip>
                    </div>
                    <br></br>
                    <div className="w-full mb-3 flex">


                        <div className="w-1/7 radio-group" style={{ marginLeft: '10px' }}>
                            <div className="flex items-center">
                                <label className="block uppercase tracking-wide   mr-2" style={{ color: 'brown' }}>
                                    <input type="radio" name="Others" value="1"
                                        checked={selectedCompanies === "1"}
                                        onChange={handleChange} />
                                    Others
                                </label>
                                <label className="block uppercase tracking-wide  mr-2" style={{ color: 'darkgreen' }}>
                                    <input type="radio" name="schneider" value="2"
                                        checked={selectedCompanies === "2"}
                                        onChange={handleChange} />
                                    Schneider
                                </label>
                                <label className="block uppercase tracking-wide   mr-2" style={{ color: 'orangered' }}>
                                    <input type="radio" name="brother" value="3"
                                        checked={selectedCompanies === "3"}
                                        onChange={handleChange} />
                                    Brother
                                </label>
                            </div>
                        </div>

                        {(selectedCompanies === "2" || selectedCompanies === "3") && (
                            <>
                                <div className="w-1/4 mr-2">
                                    <label
                                        className="block tracking-wide text-black text-base  mb-2"
                                        htmlFor="callSerialNo"
                                    >
                                        Company Call Number
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={companyCallNo}
                                        onChange={(e) => setCompanyCallNo(e.target.value)}
                                        type="text"
                                        maxLength={25}
                                        style={{ backgroundColor: 'white' }}
                                        placeholder="Enter Company call No"
                                    />
                                </div>
                            </>
                        )}



                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="callSerialNo">
                                Call Serial Number
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={billno.CallSerialNo}
                                placeholder="Enter Call Serial No"
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Name
                            </label>


                            <Select
                                value={selectedCustomer}
                                onChange={handleCustomerChange}
                                options={customerOptions}
                                placeholder="Search Customer"
                                isSearchable
                            />

                        </div>
                        <div className="w-1/7 mr-2">
                            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Customer Type
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={customertype}
                                onChange={(e) => setCustomertype(e.target.value)} type="text" placeholder="customerType"
                                disabled
                                style={{ backgroundColor: 'white' }}
                            />
                        </div>
                    </div>
                    <div className="w-full mb-3 flex">



                        {/*Warranty check here if the customer is under AMC or not*/}
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                AMC
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={amc}
                                onChange={(e) => setAMC(e.target.value)} type="text" placeholder="customerType"
                                disabled
                                style={{ backgroundColor: 'white' }}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                WarrentyExpireDate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={amcExpire}
                                onChange={(e) => setAMCExpire(e.target.value)} type="text" placeholder="AMC Expire Date"
                                disabled
                                style={{ backgroundColor: 'white' }}
                            />
                        </div>
                        {/* {end} */}
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base  mb-2" htmlFor="contactNumber1">
                                ContactNo
                            </label>
                            <Select
                                value={selectedCustomerNo}
                                onChange={handleCustomerNoChange}
                                options={customerNoOptions}
                                placeholder="Search PH:No"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="email">
                                Email
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                disabled
                                style={{ backgroundColor: 'white' }}
                                placeholder="Enter Email" />
                        </div>

                    </div>
                    <div className="w-full mb-3 flex">
                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base mb-2" htmlFor="AddressLine1">
                                AddressLine
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={addressLine1}
                                onChange={(e) => setAddressLine1(e.target.value)}
                                type="text"
                                disabled
                                style={{ backgroundColor: 'white' }}
                                placeholder="Enter Address Line" />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block  tracking-wide text-black text-base  mb-2" htmlFor="landmark">
                                Landmark
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={landmark}
                                onChange={(e) => setLandmark(e.target.value)}
                                type="text"
                                disabled
                                style={{ backgroundColor: 'white' }}
                                placeholder="Enter Landmark"
                            />
                        </div>




                    </div>
                    <div className="w-full mb-3 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="category" style={{ fontSize: '16px' }}>
                                Category
                            </label>

                            <Select
                                value={selectedProductType} // Selected product category
                                onChange={handleProductChange} // Handler for product category change
                                options={productTypeOptions} // Options for product categories
                                placeholder="Select Category"
                                isSearchable
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="brand" style={{ fontSize: '16px' }}>
                                Brand
                            </label>

                            <Select
                                value={selectedRequestType} // Selected brand
                                onChange={handleBrandChange} // Handler for brand change
                                options={requestTypeOptions} // Options for brands
                                placeholder="Select Brand"
                                isSearchable
                                isDisabled={!selectedProductType} // Disable if no product category is selected
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="productModel" style={{ fontSize: '16px' }}>
                                Product Model
                            </label>

                            <Select
                                value={selectedPmodelType} // Selected product model
                                onChange={handleModelChange} // Handler for product model change
                                options={PmodelTypeOptions} // Options for product models
                                placeholder="Select Product Model"
                                isSearchable
                                isDisabled={!selectedRequestType} // Disable if no brand is selected
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-base mb-2" htmlFor="name">
                                Model Serial No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={modal}
                                onChange={(e) => setModal(e.target.value)}
                                type="text"
                                placeholder="Enter Model"
                                maxLength={25}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                Warranty
                            </label>

                            <Select
                                value={selectedWarrantyType}
                                onChange={handleWarrantyChange}
                                options={warrantyTypeOptions}
                                placeholder="Warranty-Type"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/6 mr-2">
                            <span className="text-xs font-bold" style={{ fontSize: '14px', color: 'brown' }}>Is Priority ?</span>
                            <label className="flex items-center" style={{ fontSize: '30px', marginTop: '10px', marginLeft: '-70px' }}>
                                <input
                                    type="checkbox"
                                    name="IsPriority"
                                    checked={IsPriority}
                                    onChange={(e) => setIsPriority(e.target.checked)}
                                    className="mr-2"
                                />
                            </label>

                        </div>
                    </div>
                    <div className="w-full mb-3 flex">
                        <div className="w-full mr-1 ">
                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                                Remark <span style={{ color: 'red' }}>*</span>
                            </label>
                            <textarea
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={Remark}
                                onChange={(e) => setRemark(e.target.value)}
                                placeholder="Enter Remarks"
                                rows={3}
                                maxLength={250}
                            />
                        </div>

                    </div>


                </form>

                <Modal open={isModalOpen} onClose={closeModal} className={isModalOpen ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1300px' }}>
                            <div className="w-full mb-4 flex">

                                <form onSubmit={submitCustomData}>

                                    <div className='w-full mb-2 flex items-center'>
                                        <h5 className='psheading flex-grow linkcolor' style={{ fontWeight: 'bolder', color: 'darkmagenta', textAlign: 'center' }}>CUSTOMER CREATE</h5>
                                    </div>
                                    {errorMessages && <p className="text-red-500">{errorMessages}</p>}
                                    {successMessages && <p className="text-green-500">{successMessages}</p>}
                                    <br></br>
                                    <div className="w-full mb-3 flex">
                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                Customer Type
                                            </label>

                                            <Select
                                                value={selectedCustomerType}
                                                onChange={handleCustomerTypeChange}
                                                options={customerTypeOptions}
                                                placeholder="Customer-Type"
                                                isSearchable
                                            />
                                        </div>
                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                Name
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={names}
                                                onChange={(e) => setNames(e.target.value)}
                                                type="text"
                                                placeholder="Enter Name"
                                            />
                                        </div>
                                        {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && (

                                            <div className="w-1/4 mr-2">
                                                <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                    Contact Person
                                                </label>
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    value={contactPersons}
                                                    onChange={(e) => setcontactPersons(e.target.value)}
                                                    type="text"
                                                    placeholder="Contact person"
                                                />
                                            </div>
                                        )}
                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                ContactNo:1
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={contactNumber1s}
                                                onChange={(e) => {
                                                    const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                                    if (input.length <= 15) {
                                                        setContactNumber1s(input);
                                                    }
                                                }}
                                                type="text"
                                                placeholder="Contact Number 1"
                                            />
                                        </div>

                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                ContactNo:2
                                            </label>
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={contactNumber2s}
                                                onChange={(e) => {
                                                    const input = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                                    if (input.length <= 15) {
                                                        setContactNumber2s(input);
                                                    }
                                                }}
                                                type="text"
                                                placeholder="Contact Number 2"
                                            />
                                        </div>

                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                Email
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={emails} onChange={(e) => setEmails(e.target.value)} type="text" placeholder="Email" />
                                        </div>


                                    </div>

                                    <div className="w-full mb-3 flex">
                                        {selectedCustomerType && (selectedCustomerType.label === 'IGST' || selectedCustomerType.label === 'B to B') && (

                                            <div className="w-1/4 mr-2">
                                                <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                    GST Number
                                                </label>
                                                <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                    value={gstNumbers} onChange={(e) => setGstNumbers(e.target.value)} maxLength={15} type="text" placeholder="GST Number" />
                                            </div>
                                        )}
                                        <div className="w-1/2 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                Address Line 1
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={addressline1s} onChange={(e) => setAddressLine1s(e.target.value)} type="text" placeholder="Address Line 1" />
                                        </div>

                                        <div className="w-1/2 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                Address Line 2
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={addressline2s} onChange={(e) => setAddressLine2s(e.target.value)} type="text" placeholder="Address Line 2" />
                                        </div>

                                    </div>
                                    <div className="w-full mb-3 flex">
                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                PIN Code
                                            </label>

                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={fetchOptions}
                                                onInputChange={handleInputChange}
                                                onChange={handleChangeDrop}
                                                value={selectedOption}
                                            />
                                        </div>

                                        <div className="w-1/2 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                LandMark
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={landMarks} onChange={(e) => setLandMarks(e.target.value)} type="text" placeholder="Landmark" />
                                        </div>
                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                City
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={towns} onChange={(e) => setTowns(e.target.value)} type="text" placeholder="City" />
                                        </div>

                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                District
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={districts} onChange={(e) => setDistricts(e.target.value)} type="text" placeholder="District" />
                                        </div>

                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                State
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={states} onChange={(e) => setStates(e.target.value)} type="text" placeholder="State" />
                                        </div>
                                        <div className="w-1/4 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                Country
                                            </label>
                                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={countrys} onChange={(e) => setCountrys(e.target.value)} type="text" placeholder="Country" readOnly />
                                        </div>
                                    </div>
                                    {/* <div className="w-full mb-4 flex">
                                        <div className="w-1/7 radio-group" style={{ marginLeft: '10px' }}>
                                            <div className="flex items-center">
                                                <label className="block uppercase tracking-wide   mr-2" style={{ color: 'brown' }}>
                                                    <input type="radio" name="AMC" value="1"
                                                        checked={selectedAMC === "1"}
                                                        onChange={handleChanges} />
                                                    non-AMC
                                                </label>
                                                <label className="block uppercase tracking-wide   mr-2" style={{ color: 'darkgreen' }}>
                                                    <input type="radio" name="AMC" value="2"
                                                        checked={selectedAMC === "2"}
                                                        onChange={handleChanges} />
                                                    AMC
                                                </label>
                                            </div>
                                        </div>


                                        {selectedAMC === "2" && (
                                            <>
                                                <div className="w-1/6 mr-2">
                                                    <label
                                                        className="block tracking-wide text-black text-xs  mb-2 mr-4"
                                                        htmlFor="toDate"
                                                        style={{ fontSize: '15px', fontWeight: 'bolder' }}
                                                    >
                                                        Warranty Expired Date
                                                    </label>
                                                    <input
                                                        type="date"
                                                        className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                        value={warrentyDate || ''}
                                                        onChange={handleToDateChangeWarrentyDate}
                                                    />
                                                </div>

                                            </>
                                        )}


                                    </div> */}
                                    <div className="w-full mb-4 flex flex-wrap">
                                        <div className="w-full md:w-1/6 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="code" style={{ fontSize: '16px' }}>
                                                Warranty Options
                                            </label>
                                            <Select
                                                value={selectedCustomerWarrantyOptionsType}
                                                onChange={handleCustomerWarrantyChange}
                                                options={customerWarrantyOptionsOptions}
                                                placeholder="Warranty Options"
                                                isSearchable
                                            />
                                        </div>

                                        {(selectedCustomerWarrantyOptionsType.label === "AMC" || selectedCustomerWarrantyOptionsType.label === "WARRANTY") && (
                                            <div className="w-full md:w-1/6 mr-2">
                                                <label
                                                    className="block tracking-wide  text-xs mb-2"
                                                    htmlFor="toDate"
                                                    style={{ fontSize: '15px', fontWeight: 'bold', color: 'red' }}
                                                >
                                                    Warranty Expired Date
                                                </label>
                                                <input
                                                    type="date"
                                                    className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                                                    value={warrentyDate || ''}
                                                    onChange={handleToDateChangeWarrentyDate}
                                                />
                                            </div>
                                        )}

                                        <div className="w-full md:w-1/2 mr-2">
                                            <label className="block tracking-wide text-black text-xs mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                                                Remark
                                            </label>
                                            <textarea
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                                value={customerRemarks}
                                                onChange={(e) => setCustomerRemarks(e.target.value)}
                                                placeholder="Enter Remarks"
                                                rows={3}
                                                maxLength={250}
                                            />
                                        </div>

                                    </div>


                                    <div className="w-full mb-4 flex">
                                        <Button
                                            variant="contained"
                                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                                            onClick={submitCustomData}
                                        >
                                            Add Customer
                                        </Button>

                                        <Button
                                            variant="contained"
                                            color="error"
                                            component={Link}
                                            onClick={closeModal}
                                            className="linkcolor"
                                            style={{ marginLeft: '8px' }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10 ">
                        <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                            <div className="flex justify-end mt-2">
                                <button className="close-button md:static md:mr-2" onClick={handleHistoryBackButtonClick} style={{ marginTop: '-20px', color: 'black' }}>
                                    <Tooltip title="Close">
                                        <FaTimes />
                                    </Tooltip>
                                </button>
                            </div>
                            <h5 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'brown', fontWeight: 'bolder' }}>HISTORY</h5>
                            <div className="used-items-container">
                                {historys.length === 0 ? (
                                    <p>No history found</p>
                                ) : (
                                    historys.map((item, index) => (
                                        <div key={index} className="card" style={{ backgroundColor: getStatusColor(item.workstatus), marginBottom: '10px' }}>
                                            <div className="card-body">
                                                <p style={{ color: 'black' }}><strong>Date: {item.servicedate && new Date(item.servicedate).toLocaleDateString('en-GB')}</strong></p>
                                                <p style={{ marginTop: '-20px', color: 'black' }}><strong>Issue: {item.remarks}</strong></p>
                                                <p style={{ marginTop: '-20px', color: 'black' }}><strong>EngRemarks: {item.engineerremarks}</strong></p>
                                                <p style={{ marginTop: '-20px', color: 'black' }}><strong>PDT: {item.productname}</strong></p>
                                                <p style={{ marginTop: '-20px', color: 'black' }}><strong>Model: {item.modal}</strong></p>
                                                <p style={{ marginTop: '-20px', color: 'black' }}><strong>Eng: {item.engineerName}</strong></p>
                                                <p style={{ marginTop: '-20px', color: 'black' }}><strong>Status: {item.workstatus}</strong></p>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>

                        </div>
                    </div>
                </Modal>

            </div >
        </Fragment >
    );
};
